import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import ZiyaretciForm from './components/ZiyaretciForm';
import AdminDashboard from './components/AdminDashboard';
import Rapor from './components/Rapor';
import Grafik from './components/Grafik';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const user = localStorage.getItem('user');
    
    if (token && user) {
      setIsAuthenticated(true);
      const userData = JSON.parse(user);
      setUserRole(userData.role);
    }
  }, []);

  const ProtectedRoute = ({ children, adminOnly = false }) => {
    if (!isAuthenticated) {
      return <Navigate to="/" replace />;
    }
    
    if (adminOnly && userRole !== 'admin') {
      return <Navigate to="/form" replace />;
    }
    
    return children;
  };

  return (
    <Router>
      <div className="App">
        <div className="logo-container">
          <img 
            src="/mimb_logo.png" 
            alt="Mim Bytes Logo" 
            style={{ 
              maxHeight: '80px', 
              marginBottom: '10px',
              animation: 'fadeIn 1s ease-in'
            }} 
          />
          <h1>ZİYARETÇİ KAYIT SİSTEMİ</h1>
        </div>
        
        <Routes>
          <Route 
            path="/" 
            element={
              isAuthenticated ? 
                <Navigate to="/form" replace /> : 
                <Login setIsAuthenticated={setIsAuthenticated} setUserRole={setUserRole} />
            } 
          />
          
          <Route 
            path="/form" 
            element={
              <ProtectedRoute>
                <ZiyaretciForm userRole={userRole} />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute adminOnly={true}>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin/rapor" 
            element={
              <ProtectedRoute adminOnly={true}>
                <Rapor />
              </ProtectedRoute>
            } 
          />
          
          <Route 
            path="/admin/grafik" 
            element={
              <ProtectedRoute adminOnly={true}>
                <Grafik />
              </ProtectedRoute>
            } 
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
